import {SvgIcon} from '@mui/material';
import NavLinearGradient from './NavLinearGradient';

export default function ServicesIcon({active}: { active: boolean }) {
	
	return (
		<SvgIcon width="28" height="28" viewBox="0 0 28 28" fill="none">
			<path
				d="M7.65317 0.666748H5.11984C2.19984 0.666748 0.666504 2.20008 0.666504 5.10675V7.64008C0.666504 10.5467 2.19984 12.0801 5.1065 12.0801H7.63984C10.5465 12.0801 12.0798 10.5467 12.0798 7.64008V5.10675C12.0932 2.20008 10.5598 0.666748 7.65317 0.666748ZM22.8932 0.666748H20.3598C17.4532 0.666748 15.9198 2.20008 15.9198 5.10675V7.64008C15.9198 10.5467 17.4532 12.0801 20.3598 12.0801H22.8932C25.7998 12.0801 27.3332 10.5467 27.3332 7.64008V5.10675C27.3332 2.20008 25.7998 0.666748 22.8932 0.666748ZM22.8932 15.9067H20.3598C17.4532 15.9067 15.9198 17.4401 15.9198 20.3467V22.8801C15.9198 25.7867 17.4532 27.3201 20.3598 27.3201H22.8932C25.7998 27.3201 27.3332 25.7867 27.3332 22.8801V20.3467C27.3332 17.4401 25.7998 15.9067 22.8932 15.9067ZM7.65317 15.9067H5.11984C2.19984 15.9067 0.666504 17.4401 0.666504 20.3467V22.8801C0.666504 25.8001 2.19984 27.3334 5.1065 27.3334H7.63984C10.5465 27.3334 12.0798 25.8001 12.0798 22.8934V20.3601C12.0932 17.4401 10.5598 15.9067 7.65317 15.9067Z"
				fill="url(#paint0_linear_992_923)"/>
			<defs>
				<linearGradient id="paint0_linear_992_923" x1="26.7641" y1="0.666751" x2="-0.613058" y2="2.0524"
				                gradientUnits="userSpaceOnUse">
					<NavLinearGradient active={active}/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
